import { render, staticRenderFns } from "./IibbTaxesConfig.vue?vue&type=template&id=097c15a9&scoped=true"
import script from "./IibbTaxesConfig.vue?vue&type=script&lang=js"
export * from "./IibbTaxesConfig.vue?vue&type=script&lang=js"
import style0 from "./IibbTaxesConfig.vue?vue&type=style&index=0&id=097c15a9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "097c15a9",
  null
  
)

export default component.exports